import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import BASEURL from '../BaseUrl';
import { logoutApi } from './AuthApi';

// export const getClientByUserGroup = async (user_group) => {
//   try {
//     const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
//     return await axios.get(`${BASEURL}/user-mgmt/get-pending-user`, {
//          headers: { Authorization: `Bearer ${parseToken}` },
//       params: { user_group },
//     });
//   } catch (error) {
//     if (error.response.status === 401) {
//         await logoutApi();
//     }
//     throw error;
//   }
// };

export const getManagementUserDetails = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/user-mgmt/get-user-details`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getManagementUserDetailsByUserGroup = async (userGroup) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/user-mgmt/get-user-details-by-user-group`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { userGroup },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const updateUserStatus = async (userId, status) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.patch(`${BASEURL}/user-mgmt/status/${userId}`, null, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { status },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getRoles = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/user-mgmt/roles`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getRolesDetails = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/user-mgmt/roles/details`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/user-mgmt/create-user`, userData, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const updateUserGroups = async (userId, groupIds) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.put(
      `${BASEURL}/user-mgmt/${userId}/groups`,
      { groupIds },
      {
        headers: {
          Authorization: `Bearer ${parseToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getRolesInit = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/user-mgmt/roles/init`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const createOrUpdateRole = async (roleData) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/user-mgmt/roles`, roleData, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getRoleDetailsForEdit = async (roleId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/user-mgmt/roles/${roleId}/edit`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const updateRolePermissions = async (roleId, roleData) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.put(`${BASEURL}/user-mgmt/roles/${roleId}/permissions`, roleData, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const deleteRole = async (roleId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const response = await axios.delete(`${BASEURL}/user-mgmt/roles/${roleId}`, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      await logoutApi();
    }
    throw error;
  }
};

export const getUserPermissions = async (email) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const response = await axios.get(`${BASEURL}/user-mgmt/groups-permissions-by-email`, {
      params: { email },
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      await logoutApi();
    }
    throw error;
  }
};

export const createGroup = async (payload) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));

    const response = await axios.post(`${BASEURL}/groups`, payload, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      await logoutApi();
    }
    throw error;
  }
};

export const getGroupById = async (groupId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));

    const response = await axios.get(`${BASEURL}/groups/${groupId}`, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      await logoutApi();
    }
    throw error;
  }
};

export const getGroups = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));

    const response = await axios.get(`${BASEURL}/groups`, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      await logoutApi();
    }
    throw error;
  }
};

export const deleteGroup = async (groupId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));

    const response = await axios.delete(`${BASEURL}/groups/${groupId}`, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      await logoutApi();
    }
    throw error;
  }
};

export const updateGroup = async (groupId, payload) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));

    const response = await axios.put(`${BASEURL}/groups/${groupId}`, payload, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      await logoutApi();
    }
    throw error;
  }
};

export const getGroupInitData = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));

    const response = await axios.get(`${BASEURL}/groups/init`, {
      headers: {
        Authorization: `Bearer ${parseToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      await logoutApi();
    }
    throw error;
  }
};